var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 37,
    viewBox: "0 0 17 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.85346 18.7162V35.7894C3.85346 36.0055 4.06954 36.2217 4.28566 36.2217H10.6611C10.8773 36.2217 11.0933 36.0055 11.0933 35.7894V18.392H15.7399C15.956 18.392 16.1721 18.1759 16.1721 17.9597L16.6044 12.7729C16.6044 12.5568 16.3882 12.3407 16.1721 12.3407H11.0933V8.55864C11.0933 7.69418 11.8498 6.93777 12.7142 6.93777H16.2802C16.4963 6.93777 16.7124 6.72165 16.7124 6.50554V1.31872C16.7124 1.1026 16.4963 0.886475 16.2802 0.886475H10.337C6.77105 0.886475 3.9615 3.69601 3.9615 7.26194V12.3407H0.719737C0.503619 12.3407 0.287476 12.5568 0.287476 12.7729V17.9597C0.287476 18.1759 0.503619 18.392 0.719737 18.392H3.85346V18.7162Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3edd1398940a58a3caf855765c270434.svg";
export { ForwardRef as ReactComponent };